import styled from 'styled-components';
import BaseButton from '@sdk/components/ui/buttons/Button';

export const Button = styled(BaseButton)`
  float: right;
  font-weight: 600;
  margin: 15px 5px 5px 5px;
  width: 160px;
`;

export const Container = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
